import { Fragment } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router";
import type { MatchListingLinksFragment } from "@/graphql/generated/operations";
import { ListingReference } from "@/pages/share/listings/ListingReference";

export type LinkedListing = NonNullable<MatchListingLinksFragment["listings"]>[number];

/**
 * Die Ausschreibungen eines Matches im Fließtext: der Name und dahinter in Klammern die Kennziffer, im
 * Muster, an dem man sie überall wiedererkennt (`ListingReference`). Mit `link` führt der Name zur
 * Ausschreibung; ohne, wo ein Sprung aus dem Kontext herausreißen würde (Einstellungsdialog).
 */
export function LinkedListings({ listings, link = false }: { listings: readonly LinkedListing[]; link?: boolean }) {
  const intl = useIntl();
  const unnamed = intl.formatMessage({ id: "match.listing.unnamed", defaultMessage: "Unbenannte Ausschreibung" });
  return listings.map((listing, i) => {
    const name = listing.name || unnamed;
    return (
      <Fragment key={listing.id}>
        {i > 0 ? ", " : ""}
        {link ? (
          <Link to={`/share/listings/${listing.id}`} className="transition hover:text-ink-accent">
            {name}
          </Link>
        ) : (
          name
        )}{" "}
        (<ListingReference reference={listing.reference} />)
      </Fragment>
    );
  });
}
